import { IMedicalServiceBaseInfo } from 'interfaces';
import { BaseService } from './BaseService';
import { axiosPrivate } from 'services/axios';
class MedicalServiceBaseInfoService extends BaseService<IMedicalServiceBaseInfo> {
  constructor() {
    super('medical-services-base-info');
  }

  importFromFile = async (importFile: File, attachmentName = 'import_file') => {
    const res = await axiosPrivate.postForm(`${this.modulePrefix}/import-from-file/`, {
      [attachmentName]: importFile
    });
    return res.data;
  };
}

export const medicalServiceBaseInfoService = new MedicalServiceBaseInfoService();
